import React, { Component } from 'react';
import { static_links } from "../../constants/static_links";
import GlobalStoreService from "../../services/global-store.service";
//import '.././App.css';
import UtilService from "../../services/util.service";
import { SCRIPTS } from "../../constants/staticScripts";
import PlatformType from "../../enums/PlatformType"

const MonthlyPlan = ({ message, showPopup, template_name, handleUserAction, messageTime }) => {
    let data = message
    try {
        data = JSON.parse(data)
    }
    catch (e) {
        data = undefined
    }
    let monthly_plans = data && data.hasOwnProperty('Eligible Bill Plans for Change') ? data['Eligible Bill Plans for Change'] : data ? data : undefined;
    let proceed_click_count = 0

    const getPlanLink = () => {
        if (GlobalStoreService.get('platformType') !== "WEB") {
            if (window.MyAirtelChatAppReact) {
                //new app context
                return static_links.monthly_plans[GlobalStoreService.get('platformType')]['NEW_APP_CONTEXT']
            }
            else if (window.MyAirtelAppReact) {
                //old app context
                return static_links.monthly_plans[GlobalStoreService.get('platformType')]['OLD_APP_CONTEXT']
            }
        }
        else {
            return static_links.monthly_plans[GlobalStoreService.get('platformType')]
        }
    }

    const onProceed = (plan) => {

        let planLink = getPlanLink();

        const mobileNumberReplacedLink = UtilService.replaceAll(
            planLink,
            "{mobile}",
            GlobalStoreService.get('currentNumber')
        );

        showPopup(undefined)

        // const link = mobileNumberReplacedLink.replace("{code}", plan.code);
        let link = UtilService.replaceAll(
            mobileNumberReplacedLink,
            "{code}",
            plan.code
        );
        if (link.indexOf("&uri=") > -1) {
            const splitLink = link.split("&uri=");
            link = splitLink[0] + "&uri=" + encodeURIComponent(splitLink[1]);
        }
        window.open(link);
    }


    return (
        <div id={`plans_scroll_${messageTime.timestamp}`} style={{ alignItems: 'center', display: 'flex' }} className={`monthly-plan monthly-plan-scroll ${(false && monthly_plans && monthly_plans.length > 1) ? 'pl-10' : 'monthly-plan-single pl-67'}`} >
            {!monthly_plans && <ul className="bubbles relate pl-67 relate-0" ><li><p>{SCRIPTS.NO_SYSTEM_INFO_MESSAGE}</p></li></ul>}
            {(UtilService.getPlatformType() === PlatformType.WEB) && monthly_plans && <div className="carousel_web_arrows">
                <div><button className="arrow_button_left"
                    onClick={() => {
                        UtilService.startScrollingLeft(`plans_scroll_${messageTime.timestamp}`);
                    }}
                >&#8249;</button></div>
                <div><button className="arrow_button_right"
                    onClick={() => {
                        UtilService.startScrollingRight(`plans_scroll_${messageTime.timestamp}`);
                    }}
                >&#8250;</button></div>
            </div>}
            <ul className="carousel_list">
                {monthly_plans && monthly_plans.map((plan, index) => {
                    return (
                        <li key={index} className="monthly_plan_item">
                            <div
                                className=" plan-details color-black">
                                <span className="fs-8 display-block color-grey pl-10  pt-15">MONTHLY PLAN</span>

                                <span className="fs-20 display-block color-dark-grey  pl-10">Rs. {plan.price}</span>
                                <span className="line" />
                                <ul className="benifits">
                                    {plan.benefits && plan.benefits.map((benefit, index2) => {
                                        if (index2 < 3) {
                                            switch (benefit.shortText) {
                                                case 'Local + STD':
                                                case 'Monthly Internet':
                                                    return <li key={index2}>{benefit.finalDisplayText + ' ' + benefit.displayPackDescription}</li>
                                                case 'SMS':
                                                    return <li key={index2}>{benefit.finalDisplayText}</li>
                                                default:
                                                    return <li key={index2}>{benefit.finalDisplayText}</li>
                                            }
                                        }
                                    })}
                                </ul>
                                <button onClick={() => {
                                    handleUserAction(null)
                                    onProceed(plan)
                                }}
                                    className=" cursor-pointer billplan-card-links color-link fs-12 display-block  activate">{(template_name === 'New_Bill_Plan') ? 'VIEW DETAILS' : 'PROCEED'}</button>
                            </div>
                        </li>
                    )
                })}

            </ul>
        </div>
    );
}

export default MonthlyPlan;


// WEBPACK FOOTER //
// ./src/components/message-components/monthly_plan.component.js